import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faCompass,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen flex items-center justify-center p-4 bg-gray-50 overflow-hidden">
      {/* Soft decorative circle top-left (matches reference) */}
      <div className="pointer-events-none absolute -top-24 -left-24 w-72 h-72 rounded-full bg-blue-900/5 opacity-70" />
      <div className="pointer-events-none absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-[#fbeee170] opacity-50" />

      <div className="relative max-w-2xl w-full mx-auto text-center">
        {/* Badge pill */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-blue-200 bg-white/80 backdrop-blur-sm mb-6 shadow-sm">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className="h-3 w-3 text-blue-900"
          />
          <span className="text-sm font-semibold text-blue-900 tracking-wide">
            Page not found
          </span>
        </div>

        {/* Giant 404 — mixed colors like the reference */}
        <h1 className="select-none text-[110px] sm:text-[160px] leading-none font-black tracking-tighter">
          <span className="text-blue-800">4</span>
          <span className="text-[#ea580c]">0</span>
          <span className="text-blue-800">4</span>
        </h1>

        {/* Short accent line */}
        <div className="flex justify-center mt-2 mb-6">
          <span className="block w-10 h-1 rounded-full bg-[#ea580c]" />
        </div>

        {/* Headline */}
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">
          Oops! This destination doesn&apos;t exist
        </h2>

        {/* Subtext */}
        <p className="mt-3 text-sm sm:text-[15px] text-gray-600 max-w-md mx-auto leading-relaxed">
          Looks like you&apos;ve wandered off the trail. The page you&apos;re
          looking for may have moved or never existed.
        </p>

        {/* Action buttons */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button
            onClick={() => navigate("/")}
            className="group gap-2 w-full sm:w-auto rounded-full bg-blue-800 hover:bg-blue-900 text-white px-7 py-3 h-auto text-sm font-semibold shadow-md shadow-green-900/10 hover:shadow-lg transition-all"
          >
            <FontAwesomeIcon
              icon={faHome}
              className="h-3.5 w-3.5 transition-transform group-hover:-translate-y-0.5"
            />
            Back to home
          </Button>

          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="group gap-2 w-full sm:w-auto rounded-full border-2 border-[#ea580c] bg-transparent text-[#ea580c] hover:bg-[#ea580c] hover:text-white px-7 py-3 h-auto text-sm font-semibold transition-all"
          >
            <FontAwesomeIcon
              icon={faCompass}
              className="h-3.5 w-3.5 transition-transform group-hover:rotate-45"
            />
            Explore back
          </Button>
        </div>

        {/* Footer brand */}
        <p className="mt-12 text-sm text-gray-600 font-medium tracking-wide">
          Shop Kiganjani · Developed by{" "}
          <a
            href="https://mulsolgroup.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-900 font-semibold hover:text-[#ea580c] "
          >
            MulSol Group
          </a>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
